module.exports = __webpack_public_path__ + "static/guiding_bolt-abf9d7ba9b81f9eef76d8d1e97eceb83.jpg";